// Apertura de cuenta sin venta: la marca `?accountOpening` de la URL y el copy de la captura.

/** `?accountOpening=1` (o `true`) marca la apertura; cualquier otro valor la ignora. */
export function parseAccountOpeningFlag(value: unknown): true | undefined {
    return value === true || value === 'true' || value === 1 || value === '1' ? true : undefined;
}

/** El alta volvió marcada como apertura; un back que no conoce la marca la omite. */
export function hasAccountOpeningMark(res: { accountOpening?: boolean | null }): boolean {
    return res.accountOpening === true;
}

export const ACCOUNT_OPENING_CAPTURE_TITLE = 'Empecemos con el teléfono del cliente';
export const ACCOUNT_OPENING_CAPTURE_SUB =
    'Le llega un código por WhatsApp o SMS. Con ese número abrimos su cuenta PagoConFiado.';
export const ACCOUNT_OPENING_NO_STORE =
    'Tu usuario no tiene una tienda asignada, así que no puedes abrir una cuenta.';
export const ACCOUNT_OPENING_START_FAILED = 'No se pudo iniciar la apertura. Intenta de nuevo.';
export const ACCOUNT_OPENING_UNSUPPORTED =
    'El sistema todavía no permite abrir cuentas sin venta. Cancelamos el trámite; intenta más tarde o avisa a soporte.';
/** Motivo que viaja al silo al cancelar el alta que volvió sin la marca. */
export const ACCOUNT_OPENING_UNSUPPORTED_CANCEL_REASON =
    'El servidor no reconoció la apertura de cuenta';

// El 409 no dice si lo que retiene el número es una venta o una apertura.
export const ACCOUNT_OPENING_ACTIVE_HERE_TITLE =
    'Ya hay una venta o apertura en curso con este número';
export const ACCOUNT_OPENING_ACTIVE_HERE_HINT =
    'Continúala donde quedó. Le mandamos un código nuevo.';
export const ACCOUNT_OPENING_ACTIVE_HERE_ACTION = 'Continuarla';

// Copy del camino de la apertura: topbar, stepper y paso 01.
export const ACCOUNT_OPENING_EXIT = 'Salir de la apertura';
export const ACCOUNT_OPENING_CANCEL = 'Cancelar apertura';
export const ACCOUNT_OPENING_BRAND_SUFFIX = '· Apertura';
export const ACCOUNT_OPENING_STEPPER_LABEL = 'Progreso de la apertura';
export const ACCOUNT_OPENING_OTP_EYEBROW = 'Apertura de cuenta';
export const ACCOUNT_OPENING_OTP_SUB =
    'Ingresa los códigos y acepta los términos para abrir su cuenta.';
export const ACCOUNT_OPENING_CONSENTS_ACCEPTED =
    'El cliente ya aceptó los términos en esta apertura.';
export const ACCOUNT_OPENING_RESUMED = 'Apertura retomada: le mandamos un código nuevo.';
export const ACCOUNT_OPENING_RESUMED_SEND_FAILED =
    'Apertura retomada: el teléfono se confirma con un código nuevo.';
export const ACCOUNT_OPENING_RESUME_READY = 'Retomas la apertura donde se quedó.';

// Copy del diálogo de cancelar en la apertura: no hay cobro ni productos apartados.
export const ACCOUNT_OPENING_CANCEL_IMPACT =
    'Se descarta la apertura y el cliente se queda sin cuenta nueva. Puedes volver a empezar cuando quieras.';
export const ACCOUNT_OPENING_CANCEL_KEEP = 'Seguir con la apertura';
export const ACCOUNT_OPENING_CANCEL_REASON_PLACEHOLDER = 'Por qué se cancela la apertura';
export const ACCOUNT_OPENING_CANCELLED = 'Apertura cancelada.';

// Apertura cerrada porque el cliente ya tiene cuenta PagoConFiado.
export const ACCOUNT_OPENING_HAS_ACCOUNT_EYEBROW = 'Apertura de cuenta';
export const ACCOUNT_OPENING_HAS_ACCOUNT_TITLE = 'Este cliente ya tiene cuenta';
export const ACCOUNT_OPENING_HAS_ACCOUNT_SUB =
    'Cada cliente tiene una sola cuenta PagoConFiado; no se abre otra.';
export const ACCOUNT_OPENING_HAS_ACCOUNT_BADGE = 'Apertura cerrada';
export const ACCOUNT_OPENING_HAS_ACCOUNT_HEADLINE = 'El cliente ya tiene su cuenta PagoConFiado';
export const ACCOUNT_OPENING_HAS_ACCOUNT_BODY =
    'Este número ya tiene una cuenta abierta. No hay nada que abrir; la apertura termina aquí.';
export const ACCOUNT_OPENING_HAS_ACCOUNT_SCRIPT_LABEL = 'Dile al cliente';
export const ACCOUNT_OPENING_HAS_ACCOUNT_SCRIPT =
    '«Ya tienes tu cuenta PagoConFiado con este número. No hace falta abrir otra. Si quieres, aquí mismo te enseño los teléfonos.»';
export const ACCOUNT_OPENING_SELL_TO_CUSTOMER = 'Vender a este cliente';

// Copy del paso 02 en la apertura: perfil, cierre y espera.
export const ACCOUNT_OPENING_PROFILE_SUB = 'Contesta su perfil para abrir su cuenta.';
export const ACCOUNT_OPENING_PROFILE_HINT =
    'Pregúntaselas al cliente. Es lo que queda en su expediente.';
export const ACCOUNT_OPENING_SUBMIT = 'Abrir su cuenta';
export const ACCOUNT_OPENING_MISSING_FIELD = 'Falta esta respuesta.';
export const ACCOUNT_OPENING_READY_TITLE = 'La cuenta del cliente ya está lista';
export const ACCOUNT_OPENING_READY_SUB = 'Terminamos la apertura y seguimos con App y tarjeta.';
export const ACCOUNT_OPENING_OPENED = 'Cuenta abierta. Sigue la app y la tarjeta.';
export const ACCOUNT_OPENING_COMPLETE_FAILED = 'No se pudo cerrar la apertura.';

// Copy del paso 09 en la apertura: solo app, registro y tarjeta.
export const ACCOUNT_OPENING_DELIVERY_EYEBROW = 'App y tarjeta';
export const ACCOUNT_OPENING_DELIVERY_TITLE = 'Instala la app y entrega su tarjeta';
export const ACCOUNT_OPENING_DELIVERY_SUB = 'App, registro y tarjeta.';
export const ACCOUNT_OPENING_CARD_DEFERRED =
    'No se descontó ninguna tarjeta del inventario y la apertura puede continuar. El plástico se lo das en la próxima visita.';
export const ACCOUNT_OPENING_CARD_UNDER_REVIEW =
    'La cuenta quedó pendiente de revisión: la tarjeta va a tu bandeja de Pendientes.';
export const ACCOUNT_OPENING_NOT_BLOCKING = 'No detiene la apertura.';

// Copy del paso 10 en la apertura: solo el bono.
export const ACCOUNT_OPENING_WELCOME_PROFILE = 'Su perfil';
export const ACCOUNT_OPENING_WELCOME_PROFILE_DONE = 'Completo';
export const ACCOUNT_OPENING_WELCOME_PROFILE_HINT =
    'Ya lo contestó en Verificación, junto con su domicilio.';

// Pantalla final de la apertura.
export const ACCOUNT_OPENED_EYEBROW = 'Cierre';
export const ACCOUNT_OPENED_TITLE = '¡Cuenta abierta!';
export const ACCOUNT_OPENED_HEADLINE = 'Cuenta PagoConFiado lista';
export const ACCOUNT_OPENED_PHONE_PREFIX = 'Teléfono';
export const ACCOUNT_OPENED_OPEN_ANOTHER = 'Abrir otra cuenta';
export const ACCOUNT_OPENED_SELL_PHONE = 'Venderle un teléfono';
export const ACCOUNT_OPENED_TO_PORTAL = 'Ir al portal';

// Encabezado del paso 02 y aviso de una apertura cancelada o vencida sin motivo propio.
export const ACCOUNT_OPENING_KYC_EYEBROW = 'Apertura de cuenta';
export const ACCOUNT_OPENING_CLOSED_EYEBROW = 'Apertura cancelada';
export const ACCOUNT_OPENING_CLOSED_TITLE = 'Esta apertura ya está cancelada';
export const ACCOUNT_OPENING_CLOSED_SUB =
    'No se puede retomar: ni el código ni los pasos siguientes van a responder.';
export const ACCOUNT_OPENING_CLOSED_BODY_PREFIX = 'La apertura del teléfono';
export const ACCOUNT_OPENING_CLOSED_BODY_SUFFIX =
    'se canceló. Puedes iniciar otra con el mismo número.';
export const ACCOUNT_OPENING_EXPIRED_EYEBROW = 'Apertura vencida';
export const ACCOUNT_OPENING_EXPIRED_TITLE = 'Esta apertura venció por inactividad';
export const ACCOUNT_OPENING_EXPIRED_SUB = 'Puedes iniciar una apertura nueva con el mismo número.';
export const ACCOUNT_OPENING_TAKEN_OVER_HINT =
    'Esta apertura se canceló porque otra sucursal empezó una venta o apertura con el mismo cliente.';
export const ACCOUNT_OPENING_START_NEW = 'Iniciar una apertura nueva';
